import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

const sections = [
  { to: "/admin", label: "Overview", end: true },
  { to: "/admin/books", label: "Books" },
  { to: "/admin/posts", label: "Journal" },
  { to: "/admin/healing", label: "Healing" },
  { to: "/admin/members", label: "Members" },
  { to: "/admin/messages", label: "Letters" },
  { to: "/admin/settings", label: "Settings" },
];

export default function AdminLayout({ children, title }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const doLogout = async () => {
    await logout();
    navigate("/admin/login");
  };

  return (
    <div className="min-h-screen bg-[#F5F5F5] grid grid-cols-1 md:grid-cols-[260px_1fr]">
      <aside className="bg-white border-r border-[#E5E5E5] p-6 md:p-8 md:min-h-screen">
        <div className="font-serif text-2xl text-[#1A1F24]">
          Gemma <span className="italic text-[#C5A059]">Veda</span>
        </div>
        <div className="text-xs tracking-[0.25em] uppercase text-[#5C6670] mt-1">Studio</div>
        <nav className="mt-10 flex flex-row md:flex-col gap-1 md:gap-2 overflow-x-auto">
          {sections.map((s) => (
            <NavLink
              key={s.to}
              to={s.to}
              end={s.end}
              data-testid={`admin-nav-${s.label.toLowerCase()}`}
              className={({ isActive }) =>
                `px-4 py-3 text-sm tracking-[0.12em] uppercase transition-colors whitespace-nowrap ${
                  isActive ? "bg-[#C5A059] text-white" : "text-[#1A1F24] hover:bg-[#FAFAFA]"
                }`
              }
            >
              {s.label}
            </NavLink>
          ))}
        </nav>
        <div className="mt-12 hidden md:block">
          <div className="text-xs text-[#5C6670] mb-2">Signed in as</div>
          <div className="text-sm text-[#1A1F24]">{user?.email}</div>
          <button onClick={doLogout} data-testid="admin-logout" className="mt-4 text-xs tracking-[0.2em] uppercase text-[#5C6670] hover:text-[#C5A059]">Sign out →</button>
        </div>
      </aside>
      <main className="p-6 md:p-12">
        <div className="max-w-6xl">
          <h1 className="font-serif text-4xl md:text-5xl text-[#1A1F24]">{title}</h1>
          <div className="mt-10">{children}</div>
          <div className="md:hidden mt-12 pt-6 border-t border-[#E5E5E5]">
            <button onClick={doLogout} className="text-xs tracking-[0.2em] uppercase text-[#5C6670]">Sign out</button>
          </div>
        </div>
      </main>
    </div>
  );
}
